import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-relatorio-laudo-vidros',
  templateUrl: './relatorio-laudo-vidros.component.html',
  styleUrls: ['./relatorio-laudo-vidros.component.scss']
})
export class RelatorioLaudoVidrosComponent implements OnInit {

  @Input() template;

  display = [];
  constructor() { }

  ngOnInit() {

    this.display = this.template.elements.map( r => {
      const eName:string = r.name.toLowerCase().replace('gravacao', 'fabricacao');
      const element = this.template.elements.find( e => e.name.toLowerCase() == eName && r.name != e.name );
      
      return {
        ...r,
        dataFabricacao: element, 
      }
    }).filter(e => e);

    // Retira as informações duplicadas referente a data de fabricação ...
    for (let i = 0; i < this.display.length; i++) {
      const e = this.display[i];
      if(e.label.indexOf('Data de fabricação') >= 0) {
        this.display.splice(this.display.indexOf(e), 1);
      }
    }

  }

}
